import React from "react";
import CurrentPlanCard from "./cards/CurrentPlanCard";
import BillingHistory from "./BillingHistory";
import CancelSubscription from "./CancelSubscription";
import PaymentDetails from "./PaymentDetails";
import WalletCard from "./cards/WalletCard";


const MainContent = ({ openModal, openConfirmationModal}) => {
  return (
    <>
      <div className="flex-fill overflow-auto mt-2">
        <div className="">
          <div className="row g-4 mb-4 mx-0">
            {/* Card 1 */}
            <div className="col-lg-4 d-flex p-0">
              <CurrentPlanCard openConfirmationModal={openConfirmationModal} openModal={openModal} />
            </div>

            {/* Card 2 */}
            <div className="col-lg-4 d-flex p-0 px-md-2">
              <PaymentDetails openModal={openModal} />
            </div>

            {/* Card 3 */}
            <div className="col-lg-4 d-flex p-0 pe-md-2">
              <WalletCard openModal={openModal} />
            </div>
          </div>

          {/* Billing History */}
          <BillingHistory />
 
          {/* Cancel Subscription */}
          {/* <CancelSubscription openModal={openModal} /> */}
        </div>
      </div>
    </>
  );
};

export default MainContent;
